import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fold_1",
  "use": "icon-fold_1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fold_1\"><path d=\"M66.11 111.4h80v800h-80zM961.56 471.08H425.54l135.23-135.24-56.56-56.57-233.35 233.35 56.57 56.56 0.41-0.41L504.76 745.7l56.57-56.57-138.05-138.05h538.28z\" p-id=\"1224\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol